function ExitText() {
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ exit</span>
      </p>
      <div className="section">
        <p className="exit-msg">
          Session terminated. Connection closed.
          <span className="blinking">_</span>
        </p>
      </div>
    </>
  );
}
export default ExitText;
